export default "__VITE_ASSET__B443acF7__"